import React, {useEffect, useState} from "react";
import {useFormContext} from "react-hook-form";
import {QuestionTypes} from "../../../static/enums/Questions";
import {LatexEditor} from "../LatexEditor";

interface UnionSystemAnswerProps {
    prefix?: string;
}

export default function UnionSystemAnswer({ prefix }: UnionSystemAnswerProps) {
    const { formState, setValue, resetField } = useFormContext<any>();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (formState.dirtyFields[`${prefix}class`]) {
            setValue(`${prefix}correct_answer`, null)
            setValue(`${prefix}answer_config`, null)
            resetField(`${prefix}class`, {
                keepDirty: true,
                defaultValue: QuestionTypes.input_unions_systems
            })
        }
        setLoading(false);
    }, [])

    return (
        loading
            ? null
            : (
                <LatexEditor
                    controllerName={`${prefix}correct_answer`}
                    editorTitle={"Ответ"}
                    displayTitle={"Отображение ответа"}
                    height={"150px"}
                />
            )
    )
}